(() => {
  if (customElements.get('and-cart-countdown')) return;
  class AndCartCountdown extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      const end = this.dataset.end || '';
      if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(end)) return;
      this.deadline = Date.parse(end);
      if (!Number.isFinite(this.deadline)) return;
      this.tick();
      if (!this.expired) this.interval = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    tick() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (!remaining) {
        this.expired = true;
        clearInterval(this.interval);
        const message = this.dataset.expired || '';
        this.hidden = !message;
        this.textContent = message;
        return;
      }
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
      for (const [key, value] of Object.entries(values)) {
        const node = this.querySelector(`[data-countdown-${key}]`);
        if (node) node.textContent = String(value).padStart(2, '0');
      }
      this.hidden = false;
    }
  }
  customElements.define('and-cart-countdown', AndCartCountdown);
})();
